import { z } from 'zod';
import { paginatedQuerySchema } from '~/util/types/api';

export const usersParamsSchema = z
    .object({
        placeholder_filter: z.boolean().nullable().default(null),
        name_filter: z.string().nullable().default(null),
        ban_level_filter: z.number().nullable().default(null),
    })
    .extend(paginatedQuerySchema().shape);

export type usersParamsType = z.input<typeof usersParamsSchema>;
export const defaultUsersParams = usersParamsSchema.parse({});
